// TEMPORARY local dev tool: GetEventAvailability isn't deployed on any backend yet. Set
// `export EXPO_PUBLIC_MOCK_EVENT_AVAILABILITY=true` in your local `.envrc` (gitignored, never
// committed) to make useEventAvailability.ts generate a slot every 15 minutes across the tapped
// tile's own opensAt-closesAt span instead of hitting the network, so the slot picker sheet can be
// exercised/screenshotted locally. Leave the env var unset (the default) and the hook calls the
// real endpoint as normal.
//
// TODO: once the real endpoint ships, delete this file and the `window` param it requires on
// useEventAvailability -- the real (non-mock) path already ignores that param, so removing it is
// a clean two-file change whenever this is no longer needed.
import { EventAvailability } from '../../types/Site';

export const MOCK_EVENT_AVAILABILITY_ENABLED = process.env.EXPO_PUBLIC_MOCK_EVENT_AVAILABILITY === 'true';

export const MOCK_FETCH_DELAY_MS = 500;

export function mockAvailabilityForWindow(
  occurrenceId: string,
  opensAt: string,
  closesAt: string
): EventAvailability {
  const SLOT_MINUTES = 15;
  const SLOT_MS = SLOT_MINUTES * 60 * 1000;
  const start = new Date(opensAt).getTime();
  const end = new Date(closesAt).getTime();
  const slots = [];
  let index = 0;
  for (let slotStart = start; slotStart + SLOT_MS <= end; slotStart += SLOT_MS) {
    slots.push({
      occurrenceId,
      sourceSlotId: `mock-slot-${index}`,
      opensAt: new Date(slotStart).toISOString(),
      closesAt: new Date(slotStart + SLOT_MS).toISOString(),
      capacity: 5,
      // Every third slot is full, for a mix of bookable/full rows to look at.
      openSlots: index % 3 === 1 ? 0 : 5,
    });
    index += 1;
  }

  return {
    occurrenceId,
    retrievedAt: new Date().toISOString(),
    acceptsReservations: true,
    capacity: slots.length * 5,
    openSlots: slots.filter((slot) => slot.openSlots > 0).length * 5,
    slots,
  };
}
